/* eslint-disable */
(function webpackUniversalModuleDefinition(root, factory) {
  //created_by 150151 Date: Mon Apr 26 2021 11:49:22 GMT+0800 (China Standard Time)
  if (typeof exports === 'object' && typeof module === 'object')
    module.exports = factory();
  //created_by 150151 Date: Mon Apr 26 2021 11:49:22 GMT+0800 (China Standard Time)
  else if (typeof define === 'function' && define.amd)
    define([], factory);
  //created_by 150151 Date: Mon Apr 26 2021 11:49:22 GMT+0800 (China Standard Time)
  else if (typeof exports === 'object')
    exports["WXJsBridge"] = factory();
  //created_by 150151 Date: Mon Apr 26 2021 11:49:22 GMT+0800 (China Standard Time)
  else
    root["WXJsBridge"] = factory();
})(self, function () {
  return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for (var key in definition) {
/******/ 				if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
            /******/
          }
          /******/
        }
        /******/
      };
      /******/
    })();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
      /******/
    })();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
    })();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    __webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
      /* harmony export */
    });
    const JsBridge = {

      deviceInformation(callback) {

        invoke('deviceInformation', null, callback)

      }
      ,
      deviceAuthorization(params, callback) {

        invoke('deviceAuthorization', params, callback)

      }
      ,
      wechatHasInstall(callback) {

        invoke('wechatHasInstall', null, callback)

      }
      ,
      netWorkStatus(callback) {

        invoke('netWorkStatus', null, callback)

      }
      ,
      latitudeAndLongitude(callback) {

        invoke('latitudeAndLongitude', null, callback)

      }
      ,
      screenShot(params, callback) {

        invoke('screenShot', params, callback)

      }
      ,
      saveImage(params, callback) {

        invoke('saveImage', params, callback)

      }
      ,
      previewImage(params) {

        invoke('previewImage', params)

      }
      ,
      openLoginPage(params, callback) {

        //兼容ios 9.6之前的版本
        if (isXesApp) {
          invoke('deviceInformation', null, (_, res) => {
            if (res['appVersionNumber'] >= 90600) {
              invoke('openLoginPage', params, callback)
            } else {
              invoke('openLoginPage')
            }
          })
        }else {
          invoke('openLoginPage', params, callback)
        }

      }
      ,
      openWechatApplet(params) {

        invoke('openWechatApplet', params)

      }
      ,
      openSystemSettingsPage() {

        invoke('openSystemSettingsPage')

      }
      ,
      openWechatScanCodePage() {

        invoke('openWechatScanCodePage')

      }
      ,
      alertBySystemWithItems(params, callback) {

        invoke('alertBySystemWithItems', params, callback)

      }
      ,
      alert(params) {

        invoke('alert', params)

      }
      ,
      navigationBarInfo(callback) {

        invoke('navigationBarInfo', null, callback)

      }
      ,
      closeWebView() {

        invoke('closeWebView')

      }
      ,
      goBack(params) {

        invoke('goBack', params)

      }
      ,
      webViewHistoryList(callback) {

        invoke('webViewHistoryList', null, callback)

      }
      ,
      setNavigationBar(params) {

        if (isXesApp && isAndroid && params.leftButtonType != undefined) {
          //兼容安卓 9.8之前的版本
          invoke('deviceInformation', null, (_, res) => {
            if (res['appVersionNumber'] < 90800) {
              params.leftButtonType = params.leftButtonType == 1 ? 0 : 1
            }
            invoke('setNavigationBar', params)
          })
        } else {
          invoke('setNavigationBar', params)
        }

      }
      ,
      share(params, callback) {

        invoke('share', params, callback)

      }
      ,
      userInformation(callback) {

        invoke('userInformation', null, callback)

      }
      ,
      openNativeScheme(params) {

        invoke('openNativeScheme', params)

      }
      ,
      playVoice(params, callback) {

        invoke('playVoice', params, callback)

      }
      ,
      pauseVoice() {

        invoke('pauseVoice')

      }
      ,
      stopVoice() {

        invoke('stopVoice')

      }
      ,
      openRecordPage(params, callback) {

        invoke('openRecordPage', params, callback)

      }
      ,
      startRecord(params, callback) {

        invoke('startRecord', params, callback)

      }
      ,
      stopRecord(callback) {

        invoke('stopRecord', null, callback)

      }
      ,
      webViewBouncesEnable(params) {

        invoke('webViewBouncesEnable', params)

      }
      ,
      openPaymentPage(params, callback) {

        invoke('openPaymentPage', params, callback)

      }
      ,
      playAdvertVideo(params, callback) {

        invoke('playAdvertVideo', params, callback)

      },
      
      getWebviewRequestParam(callback) {

        invoke('getWebviewRequestParam', null, callback)

      },

      openReaderRecordPage(params, callback) {
        
        invoke('openReaderRecordPage', params, callback)
  
      },

      uploadRecordData(params, callback) {
        
        invoke('uploadRecordData', params, callback)
  
      },

      openCameraPage(params, callback) {
        
        invoke('openCameraPage', params, callback)
  
      },

      openVideoRecordPage(params, callback) {
        
        invoke('openVideoRecordPage', params, callback)
  
      },

      uploadImageData(params, callback) {
        
        invoke('uploadImageData', params, callback)
  
      },

      base64DataForPath(params, callback) {
        
        invoke('base64DataForPath', params, callback)
  
      },

      playCourseVideo(params, callback) {
        
        invoke('playCourseVideo', params, callback)
  
      },

      completePreTest(params) {

        invoke('completePreTest', params)

      },
      
      showRibbonAnimation() {

        invoke('showRibbonAnimation')

      },

      openExpressionKeyboard(params, callback) {
        
        invoke('openExpressionKeyboard', params, callback)
  
      },

      openMemberSuccess(params) {

        invoke('openMemberSuccess', params)

      }

    }

    const { toString } = Object.prototype

    const ua = navigator.userAgent
    const isAndroid = ua.includes('Android') || ua.includes('Adr')
    const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(ua)
    const isXesApp = ua.includes('jzh') && !ua.includes('mvideo_jzh')

    const isFunction = (val) => {
      return toString.call(val) === '[object Function]'
    }

    const domain = 'WXJsBridge'

    const store = {}

    let guid = Date.now()

    window.app_executeCallBack = (params) => {
      typeof params === 'string' && (params = JSON.parse(params))
      const { callbackid, result, error, continue: iscontinue } = params
      if (isFunction(store[callbackid])) {
        store[callbackid](error, result)
        if (String(iscontinue) === '0') {
          delete store[callbackid]
        }
      } else {
        console.log('callbackid not exit', params)
      }
    }

    function genId(taljsfname, fn) {
      const tag = taljsfname + guid++
      store[tag] = fn
      return tag
    }

    function send(data) {
      if (isAndroid) {
        window
          && window.talAndroidJsBridge
          && isFunction(window.talAndroidJsBridge.postMethod)
          && window.talAndroidJsBridge.postMethod(data, domain)
      } else if (isIOS) {
        window
          && window.webkit
          && window.webkit.messageHandlers
          && window.webkit.messageHandlers[domain]
          && isFunction(window.webkit.messageHandlers[domain].postMessage)
          && window.webkit.messageHandlers[domain].postMessage(data)
      }
    }

    function invoke(taljsfname, params, callback) {
      const data = {
        taljsfname
      }

      if (params && Reflect.ownKeys(params).length) {
        data.params = params
      }

      if (isFunction(params)) {
        data.callbackid = genId(taljsfname, params)
      }

      if (isFunction(callback)) {
        data.callbackid = genId(taljsfname, callback)
      }

      send(JSON.stringify(data))
    }

  /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (JsBridge);
/******/ 	return __webpack_exports__;
    /******/
  })()
    ;
});